import { Filter } from '@anytag/shared-molecules';
import { Template, TemplateProps } from './Template';
import { useMarketplaceCommissionsFilter } from './hooks';

export type MarketplaceCommissionsFilterProps = TemplateProps;

export const MarketplaceCommissionsFilter = (props: MarketplaceCommissionsFilterProps) => {
  const { filter, setFilterForm } = useMarketplaceCommissionsFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter} className="rounded-none">
      <Template {...props} />
    </Filter.Provider>
  );
};

export { useMarketplaceCommissionsFilter };
export * from './schemaTypes';
